import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { SiteV2 } from 'src/app/shared/models';
import { BasicService } from 'src/app/shared/services/basic.service';
import { Report, ScenarioSimpleInfo } from '../../../models';

@Component({
  selector: 'app-report-edition-verbatim-dialog',
  templateUrl: '../report-edition-dialog.component.html',
  styleUrls: ['../report-edition-dialog.component.scss'],
})
export class ReportEditionVerbatimDialogComponent implements OnInit {
  //data
  dialogTitle: string;
  sites: SiteV2[];
  report: Report;
  scenarios: ScenarioSimpleInfo[];
  isCreation: boolean;

  //form
  isFormValid: boolean;
  clickedSave: Subject<void> = new Subject();

  constructor(
    private basicService: BasicService,
    public dialogRef: MatDialogRef<ReportEditionVerbatimDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.dialogTitle = this.data.dialogTitle;
    this.sites = this.data.sites;
    this.report = this.data.report;
    this.scenarios = this.data.scenarios;
    this.isCreation = this.data.isCreation;

    this.addUIFields(this.report);
  }

  private addUIFields(report: Report) {
    if (!report.ui) {
      report.ui = {};
    }
    report.ui.name = report.name;
    report.ui.metricName = this.basicService.translate('verbatim/title');
    report.ui.filterCriteria = this.getLabelAndFiltersForUIVerbatim(report.filters);
  }

  private getLabelAndFiltersForUIVerbatim(filters: {
    dateRange?: { from: string; to: string };
    scenarioIds?: number[];
    scoreIds?: string[];
    siteIds?: number[];
  }): { selectorLabel: string; valueLabels: string[] }[] {
    const labelAndFiltersForUi = [];
    let selectorLabel = [];
    const scenarioIds = [];

    if (filters['siteIds'].length) {
      selectorLabel = this.basicService.translate('verbatim/sites');
      const valueLabels = [];
      filters.siteIds.forEach(siteId => {
        valueLabels.push(this.getSiteNameVerbatim(siteId));
      });

      labelAndFiltersForUi.push({ selectorLabel, valueLabels });
    }

    if (filters['scenarioIds'].length) {
      selectorLabel = this.basicService.translate('verbatim/scenarios');
      const valueLabels = [];
      filters.scenarioIds.forEach(scenarioId => {
        valueLabels.push(this.getScenarioNameVerbatim(scenarioId));
        scenarioIds.push(scenarioId);
      });

      labelAndFiltersForUi.push({ selectorLabel, valueLabels });
    }

    if (filters['scoreIds'].length) {
      selectorLabel = this.basicService.translate('verbatim/scores');
      const valueLabels = [];
      filters.scoreIds.forEach(scoreId => {
        valueLabels.push(this.getScoreNameVerbatim(scoreId));
      });

      labelAndFiltersForUi.push({ selectorLabel, valueLabels });
    }

    return labelAndFiltersForUi;
  }

  private getSiteNameVerbatim(siteId: number): string {
    return this.sites.find(site => site.id === siteId).name;
  }

  private getScenarioNameVerbatim(scenarioId: number): string {
    return this.scenarios.find(scenario => scenario.id === scenarioId).name;
  }

  private getScoreNameVerbatim(scoreId: string): string {
    let label = null;
    this.scenarios.forEach(scenario => {
      if (scenario.scenario_verbatim_details) {
        scenario.scenario_verbatim_details.forEach(box => {
          box.subitems.forEach(element => {
            if (element.id === scoreId) {
              label = element.label;
            }
          });
        });
      }
    });

    return label;
  }

  changeFormValidation(formValid: boolean) {
    this.isFormValid = formValid;
  }

  saveForm() {
    this.clickedSave.next();
  }
}
